export default __webpack_public_path__ + "static/semantic-motion-mapping-428ebf29d3550d1f775d9820b32b660f.png";